import React from "react";

import Box from "../Box";

const Standard = props => {
  var classes = "hp__block hp__block--mt-standard container-fluid",
    blockSettings = props.settings.settings ? props.settings.settings : {};

  if (blockSettings.breaking_news === "1") {
    classes += " hp__block--mt-standard--breaking-news";
  }

  return (
    <section className={classes}>
      <div className="row">
        <Box
          {...props}
          id="b1"
          type="pile"
          settings={props.settings.b1}
          classes="hp__box--main col-xs-12 col-sm-6"
          gradient={true}
          thumbnailHeight="825"
        />
        <div className="hp__box--column col-xs-12 col-sm-3">
          <section className="hp__block hp__block--three container">
            <div className="row hp__block__row hp__block__row--first">
              <Box
                {...props}
                id="b1"
                type="news"
                settings={props.settings.b2}
                classes="col-xs-6 col-md-4"
              />
              <Box
                {...props}
                id="b2"
                type="news"
                settings={props.settings.b3}
                classes="col-xs-6 col-md-4 hp__box__xs__right"
              />
              <Box
                {...props}
                id="b3"
                type="news"
                settings={props.settings.b4}
                classes="col-xs-12 col-md-4"
              />
            </div>
          </section>
        </div>

        <Box {...props} id="b5" type="list" settings={props.settings.b5} />
      </div>
    </section>
  );
};

export default Standard;
